import { Heading, Text } from 'ui-kit/typography'
import { BreadcrumbsNavigation, isBreadcrumb } from 'routes/components/Shared'
import { CONSOLE_LINK, LINKS } from 'routes/constants'
import clsx from 'clsx'
import classes from './IntegrationPageHeader.module.scss'

export function IntegrationPageHeader({ integration }) {
  const title = `${integration.name} API Integration Profile`
  const breadcrumbs = [
    {
      href: LINKS.INTEGRATIONS,
      name: 'Integrations',
    },
    { name: title },
  ].filter(isBreadcrumb)

  return (
    <section className={classes.section}>
      <BreadcrumbsNavigation
        breadcrumbs={breadcrumbs}
        className={classes.breadcrumbs}
      />
      <div className={classes.header}>
        <img
          src={integration.logoUri}
          width={64}
          height={64}
          fetchPriority='high'
          className={classes.header_logo}
          alt={`${integration.name} Logo`}
        />
        <hgroup>
          <Heading as={'h1'} lh={'loose'}>
            {title}
          </Heading>
          <Text size={'lg'} className={classes.header_subtitle}>
            Information and guides about integrating with {integration.name} API
          </Text>
        </hgroup>
        <a
          href={CONSOLE_LINK}
          className={clsx('btn btn--primary', classes.header_consoleLink)}
        >
          <span className='btn__content'>
            Add {integration.name} Integration to Your App
          </span>
        </a>
      </div>
    </section>
  )
}
